import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=491c1c46&scoped=true&"
import script from "./page7.vue?vue&type=script&lang=ts&"
export * from "./page7.vue?vue&type=script&lang=ts&"
import style0 from "./page7.vue?vue&type=style&index=0&id=491c1c46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491c1c46",
  null
  
)

export default component.exports